import { NavLink } from "react-router-dom";
import {
  FaTachometerAlt,
  FaUsers,
  FaBoxOpen,
  FaArrowLeft,
} from "react-icons/fa";

export default function Sidebar() {
  const links = [
    {
      name: "Dashboard",
      to: "/xadmin",
      icon: <FaTachometerAlt />,
      end: true,
    },
    {
      name: "Users",
      to: "/xadmin/users",
      icon: <FaUsers />,
    },
    {
      name: "Scripts",
      to: "/xadmin/scripts",
      icon: <FaBoxOpen />,
    },
    {
      name: "Algorithm",
      to: "/xadmin/algorithm",
      icon: <FaBoxOpen />,
    },
    {
      name: "Tasks",
      to: "/xadmin/tasks",
      icon: <FaBoxOpen />,
    },
    {
      name: "DB Manager",
      to: "/xadmin/dbmgr",
      icon: <FaBoxOpen />,
    },
    {
      name: "Settings",
      to: "/xadmin/psettings",
      icon: <FaBoxOpen />,
    },
    {
      name: "Scans",
      to: "/xadmin/scans",
      icon: <FaBoxOpen />,
    },
    {
      name: "Backtest",
      to: "/xadmin/backtest",
      icon: <FaBoxOpen />,
    },
    {
      name: "Backtest Value",
      to: "/xadmin/vbacktest",
      icon: <FaBoxOpen />,
    },
  ];

  return (
    <aside
        className="
            w-64
            min-h-[calc(100vh-5rem)]
            bg-black/30
            border-r
            border-green-500/20
            backdrop-blur-xl
        "
    >

      <div className="p-6">

        <h1 className="text-2xl font-bold bg-gradient-to-r from-green-400 to-emerald-400 bg-clip-text text-transparent">
          Menu
        </h1>

        <nav className="mt-10 space-y-2">

          {links.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${
                  isActive
                    ? "bg-green-500/20 border border-green-500/30 text-green-300 shadow-[0_0_20px_rgba(34,197,94,.15)]"
                    : "text-gray-400 hover:bg-white/5 hover:text-white"
                }`
              }
            >
              <span className="text-lg">{link.icon}</span>

              {link.name}
            </NavLink>
          ))}

          <a
            href={process.env.REACT_APP_FRONTEND_URL}
            className="
              mt-4
              flex items-center justify-center gap-3
              rounded-xl
              border border-cyan-500/30
              bg-gradient-to-r from-cyan-500/10 to-blue-500/10
              px-4 py-3
              text-cyan-300
              font-medium
              transition-all
              hover:from-cyan-500/20
              hover:to-blue-500/20
              hover:text-white
              hover:shadow-[0_0_20px_rgba(34,211,238,.25)]
            "
          >
            <FaArrowLeft />
            Exit Admin Panel
          </a>
        </nav>
      </div>
    </aside>
  );
}